import { Button, Dialog, DialogTitle, Divider, IconButton, InputLabel, Select, Typography,TextField,MenuItem,DialogContent,FormControl,Stack,Box } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash'

const CreateIssue = ({openIssueModal,onCloseIssue,setIssueData,issueData,setIssueDescription,issueDescription,issueList,issueListId,setIssueListId,onSaveIssue}) => {
    const titleListName=_.find(issueList,it=>it?.issueListId===issueListId)?.name
  return (
    <Dialog open={openIssueModal} onClose={onCloseIssue}
    maxWidth="md"
    fullWidth
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    unmountonexit={"true"}
>
    <DialogTitle sx={{ m: 0, p: 2, display: 'flex' }}>
        <Typography variant='h4'> {`Add to ${titleListName}`}</Typography>

        <IconButton
            aria-label="close"
            onClick={onCloseIssue}
            sx={{
                position: 'absolute',
                right: 12,
                top: 12,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon />
        </IconButton>
    </DialogTitle>
    <Divider />
    <DialogContent>
    <Stack spacing={2}>
    {/* <FormControl size="small" sx={{ width: '150px' }}>
    <InputLabel>Issue List</InputLabel>
    {<Select label='Issue List' size="small" value={issueListId} onChange={e=>setIssueListId(e.target.value)}>
      {_.map(issueList, it => <MenuItem key={it.issueListId} value={it.issueListId}>{it?.name}</MenuItem>)}
    </Select>} 
  </FormControl> */}
    <TextField
        multiline rows={4}
        sx={{ width: "100%", }}
        type="text"
        label="Description"
        variant="outlined"
        value={issueDescription}

        onChange={(e) => setIssueDescription(e.target.value)}
    />
    <TextField
        
        // multiline rows={3}
        sx={{ width: "100%" }}
        
        type="text"
        label={'Data'}
        variant="outlined"
        value={issueData}

        onChange={(e) => setIssueData(e.target.value)}
    />
   
    </Stack>
    </DialogContent>
    <Divider />
    <Box sx={{ display: "flex", justifyContent: "start", m: "10px",ml:3,py:1 }}>
    <Button
        color="primary"
        variant="outlined"
        size="small"
         onClick={(e) => onSaveIssue()}
         disabled={!issueListId}
    >
        Save
    </Button>
        {/* <Button onClick={(e) => onConfirm()} variant="contained" color="error" sx={{ ml: 2, bgcolor: (theme) => theme.palette.error.light }} >  Yes</Button> */}
        <Button color="secondary" variant="text" onClick={onCloseIssue} sx={{ px: 3, marginLeft: '10px' }} size="small"> Close </Button>
    </Box>
</Dialog>
  )
}

export default CreateIssue